import React, { useEffect, useState } from 'react';
import './css/index.scss';
import SearchInput from '../../../../components/SearchInput';
import MyButton from '../../../../components/MyButton';
import Api from '../../../../Api';
import sendRequest from '../../../../helpers/sendRequest';
import MyModal from '../../../../components/MyModal';

const MIN_VALUE = 0.6;
const MAX_VALUE = 999999;
const DECIMAL_REGEX = /^\d*(\.\d{0,2})?$/;

function parseDisplayValue(v) {
  if (v == null || v === '') return '';
  if (typeof v === 'number') return Number.isNaN(v) ? '' : String(v);
  if (typeof v === 'string') return v;
  return '';
}

function PersonalServiceSettings({ data, loading, onUpdate }) {
  const [value, setValue] = useState('');
  const [saving, setSaving] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalText, setModalText] = useState('');
  const [modalState, setModalState] = useState('');

  const setting = data?.settings?.[0];
  const isReady = data?.action_to_pay_for === 'personal_service' && (setting || data?.settings?.length === 0);

  const currentCurrency = (setting?.currency || 'usd').toUpperCase();

  useEffect(() => {
    if (setting != null) {
      setValue(parseDisplayValue(setting.value));
    }
  }, [setting?._id, setting?.value]);

  const handleChange = (e) => {
    const raw = e?.target != null ? e.target.value : (typeof e === 'string' || typeof e === 'number' ? e : '');
    const str = String(raw ?? '');
    if (str === '' || DECIMAL_REGEX.test(str)) {
      setValue(str);
    }
  };

  const handleSave = async () => {
    const trimmed = value.replace(/,/, '.').trim();
    const num = Number(trimmed);
    if (trimmed === '' || Number.isNaN(num)) {
      setModalText('Введите число в формате X.XX (например 5.99).');
      setModalState('error');
      setModalVisible(true);
      return;
    }
    if (num < MIN_VALUE) {
      setModalText(`Минимальное значение: ${MIN_VALUE}.`);
      setModalState('error');
      setModalVisible(true);
      return;
    }
    if (num > MAX_VALUE) {
      setModalText(`Максимальное значение: ${MAX_VALUE}.`);
      setModalState('error');
      setModalVisible(true);
      return;
    }
    const rounded = Math.round(num * 100) / 100;
    if (!setting?._id) {
      setModalText('Настройка не загружена.');
      setModalState('error');
      setModalVisible(true);
      return;
    }

    const res = await sendRequest({
      request: Api.updatePaymentSetting,
      payload: { id: setting._id, value: rounded },
      warnErrorText: 'while updating personal_service setting',
      setLoading: setSaving,
    });

    if (res?.status === 'ok') {
      setModalText('Сохранено.');
      setModalState('success');
      setModalVisible(true);
      onUpdate();
    } else {
      setModalText(res?.message || 'Ошибка сохранения.');
      setModalState('error');
      setModalVisible(true);
    }
  };

  if (loading && !setting) {
    return <p className="personal_service_settings_loading">Загрузка...</p>;
  }

  if (!isReady) {
    return null;
  }

  return (
    <div className="personal_service_settings">
      <h3 className="personal_service_settings_title">Настройки персональной услуги</h3>
      <p className="personal_service_settings_desc">Одна запись: базовая сумма и валюта. Редактирование через форму ниже.</p>

      {setting ? (
        <>
          <p className="personal_service_settings_hint">Допускается только формат X.XX (две цифры после запятой). Значение от {MIN_VALUE} до {MAX_VALUE}.</p>
          <div className="personal_service_settings_form">
            <SearchInput
              wrapperClassName="personal_service_settings_input"
              labelText="Сумма (value)"
              value={value}
              onChange={handleChange}
              withLeftIcon={false}
              placeholder="0.00"
            />
            <p className="personal_service_settings_currency">Валюта: {currentCurrency}</p>
            <MyButton
              text="Сохранить"
              onClick={handleSave}
              loading={saving}
              className="personal_service_settings_btn"
            />
          </div>
        </>
      ) : (
        <p className="personal_service_settings_empty">Запись настроек не найдена.</p>
      )}

      <MyModal isOpen={modalVisible} closeFunction={() => setModalVisible(false)}>
        <div style={{ padding: '20px' }}>
          <p style={{ whiteSpace: 'pre-wrap', marginBottom: '20px' }}>{modalText}</p>
          <MyButton text={modalState === 'error' ? 'Закрыть' : 'ОК'} onClick={() => setModalVisible(false)} />
        </div>
      </MyModal>
    </div>
  );
}

export default PersonalServiceSettings;
